export default __webpack_public_path__ + "static/media/multiply-hover.cf7bbe2f.svg";